<template>
    <el-card class="box-card order-detail-section mg20">
        <div slot="header" class="clearfix">
            <span>审批不通过记录汇总</span>
<!--            <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
        </div>

        <el-table :data="logs" style="width: 100%" size="small">
            <el-table-column prop="created_at" label="审批时间"></el-table-column>
            <el-table-column prop="executor_name" label="审批人"></el-table-column>
            <el-table-column prop="flow_type_text" label="审批类型"></el-table-column>
            <el-table-column prop="reason_text" label="不通过原因">
            </el-table-column>
        </el-table>

    </el-card>
</template>

<script>

    import OrderAuditService from "~/services/OrderAuditLog";
    export default {
        name: "OrderAuditLog",
        props: {
            orderId: {
                type: Number|String,
                required: true
            }
        },
        data() {
            return {
                logs: [],
                loading: false
            };
        },
        created() {
            this.getLogs();
        },
        methods: {
            getLogs() {
                OrderAuditService.getListWithOrder(this.orderId).then(res => {
                    if (res.code == 0) {
                        this.logs = res.data;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/approve/OrderAuditLog.vue